import styled from "styled-components";

export const Title = styled("h2")`
  margin: 0px;
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;
  text-align: center;
  position: relative;
`;
export const SubTitle = styled("p")`
  margin: 0px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`;
export const Text = styled("p")`
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;
export const Image = styled("img")`
  position: absolute;
  bottom: 100%;
  left: 50%;
  display: block;
  transform: translate(-50%, 50%);
`;
